import { useTranslation } from 'react-i18next';

import SearchBar from '@/components/atoms/SearchBar/SearchBar';
import { ColumnVisibilityMenu } from '@/components/ui/table/column-visibility-menu';

import { UseAudiencePageReturn } from '../hooks/useAudiencePage';

interface AudienceToolbarProps {
  page: UseAudiencePageReturn;
}

export const AudienceToolbar = ({ page }: AudienceToolbarProps) => {
  const { t } = useTranslation();
  const showColumns = page.hideableColumns.length > 0;

  return (
    <div className="mb-4 flex items-center justify-between gap-2 pl-1">
      <SearchBar
        placeholder={t('campaigns.audience_search_dots')}
        value={page.searchQuery}
        onChange={(event) => page.handleSearchChange(event.target.value)}
      />
      {showColumns && (
        <ColumnVisibilityMenu
          columns={page.hideableColumns}
          columnVisibility={page.columnVisibility}
          onColumnVisibilityChange={page.setColumnVisibility}
          onReset={page.resetColumnVisibility}
          open={page.isCustomizeColumnsOpen}
          onOpenChange={page.setIsCustomizeColumnsOpen}
          onInteractOutside={(e) => {
            if (e.target === page.customizeButtonRef.current) {
              e.preventDefault();
              e.stopPropagation();
            }
          }}
        />
      )}
    </div>
  );
};
